
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class JzwzTable extends Vue {
    //决战五张
    table = {
        data: [],
        column: [
            {
                key: 'dealer',
                title: ' 庄牌(金花)',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.dealer[0].poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: ' 庄牌(牛牛)',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.dealer[1].poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '天',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.fu) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.fu.bet)
                    }
                    let poker = []
                    let poker1 = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.fu[0].poker
                        poker1 = JSON.parse(params.row.opt_detail).award_content.point.fu[1].poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px',
                                display: poker1.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker1.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '地',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.lu) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.lu.bet)
                    }
                    let poker = []
                    let poker1 = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.lu[0].poker
                        poker1 = JSON.parse(params.row.opt_detail).award_content.point.lu[1].poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px',
                                display: poker1.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker1.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '人',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.shou) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.shou.bet)
                    }
                    let poker = []
                    let poker1 = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.shou[0].poker
                        poker1 = JSON.parse(params.row.opt_detail).award_content.point.shou[1].poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '30px',
                                display: poker1.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker1.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'dealer',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h('span', { style: { color: color } }, str)
                }
            }
        ]
    }

    @Prop()
    listdata
}
